module.exports = __webpack_public_path__ + "img/chevron-circle-left.98c2912f.svg";